import { useTrackingEvents } from '~/composables/tracking-events/use-tracking-events'
import { useUserStore } from '#lib/stores'
import { TrackingEventName } from '~/enums'
import type {
  GameSpecificEvents,
  TrackingGameStarted,
} from '~/types/tracking-events'

export function useGameSpecificEvents() {
  const userStore = useUserStore()
  const { trackingEvents } = useTrackingEvents()

  const trackingGameStarted = (values: GameSpecificEvents) => {
    const userId = userStore.data.id
    const gaValue = useCookie('_ga').value as string
    const params: TrackingGameStarted = {
      user_id: userId || gaValue,
      game_id: values.gameId,
      game_type: values.gameType,
      game_name: values.gameName,
    }
    trackingEvents(TrackingEventName.GameStarted, params)
  }

  return {
    trackingGameStarted,
  }
}
